"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _lang = _interopRequireDefault(require("@/lang"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// import moment from 'moment'
// import Pagination from '@/components/Pagination' // secondary package based on el-pagination
// import QRCode from "qrcodejs2";
var _default = {
  name: 'agentSystemConfig:add',
  extends: _PermissionPage.default,
  components: {
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      list: null,
      templateTemp: {
        systemName: '',
        systemUrl: '',
        // logoImage: '',
        // backgroundImage: '',
        remark: ''
      },
      // rules: {
      //   systemName: [{required: true, message: i18n.t('SMS.systemName')+i18n.t('SMS.canNotBeEmpty'), trigger: 'blur'}],
      //   // upload: [{required: true, message: i18n.t('SMS.platformLOGO')+i18n.t('SMS.canNotBeEmpty'), trigger: 'blur'}],
      //   systemUrl : [{required:true, message:i18n.t('SMS.smsDomainAddress')+i18n.t('SMS.canNotBeEmpty'),trigger: 'blur'},
      //     {validator:this.domain,message:i18n.t('message.message58'),trigger: 'blur'}],
      // },
      costTemp: [],
      key: 1,
      qrcodeTemp: {
        googleQrcode: null,
        agentAccount: null
      },
      uploadUrl: process.env.VUE_APP_BASE_API + "/agentRemitOrder/auditSuccess"
    };
  },
  created: function created() {},
  computed: {
    errorInfo: function errorInfo() {
      return {
        emptySystemName: this.$t('SMS.systemName') + this.$t('SMS.canNotBeEmpty'),
        emptySystemUrl: this.$t('SMS.smsDomainAddress') + this.$t('SMS.canNotBeEmpty'),
        invalidSystemUrl: this.$t('message.message58')
      };
    },
    rules: function rules() {
      var _this = this;

      // systemName: [{required: true, message: i18n.t('SMS.systemName')+i18n.t('SMS.canNotBeEmpty'), trigger: 'blur'}],
      // // upload: [{required: true, message: i18n.t('SMS.platformLOGO')+i18n.t('SMS.canNotBeEmpty'), trigger: 'blur'}],
      // systemUrl : [{required:true, message:i18n.t('SMS.smsDomainAddress')+i18n.t('SMS.canNotBeEmpty'),trigger: 'blur'},
      //   {validator:this.domain,message:i18n.t('message.message58'),trigger: 'blur'}],
      var isEmpty = function isEmpty(obj) {
        return typeof obj == 'undefined' || obj == null || obj === '' || obj.length === 0;
      };

      var domain = function domain(rule, value, callback) {
        if (!isEmpty(value)) {
          // console.log(value);
          // if (!new RegExp("^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$").test(value)) {
          //   console.log(value);
          //   return callback(new Error(this.errorInfo.invalidSystemUrl));
          // }
          return callback();
        }

        return callback(new Error(_this.errorInfo.emptySystemUrl));
      };

      return {
        systemName: [{
          required: true,
          message: this.errorInfo.emptySystemName,
          trigger: 'blur'
        }],
        systemUrl: [{
          required: true,
          validator: domain,
          trigger: 'blur'
        }]
      };
    }
  },
  methods: {
    doResetTemp: function doResetTemp() {
      this.templateTemp = {
        systemName: '',
        systemUrl: '',
        remark: ''
      };
      this.$refs.uploadLogo.clearFiles();
      this.$refs.uploadBgImage.clearFiles();
      this.$refs["dataForm"].clearValidate();
    },
    uploadSystemConfig: function uploadSystemConfig() {
      var _this2 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          var formData = new FormData();

          if (_this2.$refs.uploadLogo.uploadFiles[0]) {
            var logo = _this2.$refs.uploadLogo.uploadFiles[0].raw;
            formData.append('logoFile', logo);
          }

          if (_this2.$refs.uploadBgImage.uploadFiles[0]) {
            var bgImage = _this2.$refs.uploadBgImage.uploadFiles[0].raw;
            formData.append('backgroundImage', bgImage);
          }

          formData.append("postInfo", new Blob([JSON.stringify({
            "systemName": _this2.templateTemp.systemName,
            "systemUrl": _this2.templateTemp.systemUrl,
            "remark": _this2.templateTemp.remark
          })], {
            type: "application/json"
          }));

          _httpUtils.default.post("agentSystemConfig", "add", null, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function (res) {
            if (res.code === 200) {
              _this2.$notify({
                title: _lang.default.t('message.message59'),
                message: res.data,
                type: 'success',
                duration: 2000
              });

              _this2.doResetTemp();
            }

            ;

            if (res.code === 500) {
              _this2.$notify({
                title: _lang.default.t('message.message42'),
                message: res.message,
                type: 'error',
                duration: 2000
              });
            }
          }).catch(function (e) {
            _this2.$notify({
              title: _lang.default.t('SMS.alarm'),
              message: _lang.default.t('message.message42') + ',' + e.message,
              type: 'warning',
              duration: 2000
            });
          });
        }
      });
    }
  }
};
exports.default = _default;